import { useQuery } from "@apollo/client";
import {
  IntegrationType,
  OrganizationIntegrationsDocument,
} from "../../__generated__/graphql";

export default function useOrganizationHasIntegrations() {
  const { data, loading, error } = useQuery(OrganizationIntegrationsDocument);

  const hasPimsIntegration = data?.integrations?.some(
    (integration) => integration?.type === IntegrationType.Pims
  );

  return { hasPimsIntegration, loading, error };
}
